import React, { useState } from "react";
import "../../assets/css/responsive.css";
import "../../assets/css/style.css";
import "../../assets/css/general.css";
import "../../assets/css/hamburger.css";

import Hero from "../../components/main/hero.jsx";
import Activite from "../../components/main/activite.jsx";
import Presence from "../../components/main/presence.jsx";
import Tool from "../../components/general/tool.jsx";
import Footer from "../../components/general/footer.jsx";

const Index = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="main">
      <Hero />
      <Activite />
      <Presence />
      <Tool />
      <Footer />
    </div>
  );
};

export default Index;
